import React, { useMemo } from 'react'

import { Card, Typography } from 'antd'
import { useFormikContext } from 'formik'
import moment from 'moment/moment'

import { PageTitle } from '../../../../../../components/PageTitle'
import { getMessage } from '../../../../../../util/IntlMessages'
import { useCreateActionContext } from '../../contexts/action'
import { BaseFields } from '../BaseFields'
import { CustomFields } from '../CustomFields'

import './styles.less'

export function ActionBody() {
  const { isNewAction, isPreview, isReadOnly } = useCreateActionContext()

  const { values, errors, handleBlur, setFieldValue } = useFormikContext()

  const pageTitle = useMemo(() => {
    if (isPreview) return getMessage('reviewAction')
    if (isReadOnly) return getMessage('viewActions')
    return isNewAction ? getMessage('createActions') : getMessage('updateActions')
  }, [isNewAction, isPreview, isReadOnly])

  return (
    <Card className="ant-card gx-card ant-card-bordered createActionBody">
      <div className="createActionBody__pageTitleWrapper">
        <PageTitle title={pageTitle} className="createActionBody__pageTitle" />

        {!isNewAction && values?.baseFields?.updatedAt && (
          <div>
            <Typography className="createActionBody__updatedAtTitle">{getMessage('updatedAt')}</Typography>
            <Typography className="createActionBody__updatedAtTitle createActionBody__updatedAtTitle--value">
              {moment(values.baseFields.updatedAt).format('DD/MM/YYYY HH:mm')}
            </Typography>
          </div>
        )}
      </div>

      <BaseFields
        values={values?.baseFields || {}}
        errors={errors?.baseFields || {}}
        setValues={setFieldValue}
        handleBlur={handleBlur}
      />
      {values?.baseFields?.actionTypeId && (
        <CustomFields
          values={values?.customFields || {}}
          errors={errors?.customFields || {}}
          setValues={setFieldValue}
          actionTypeId={values?.baseFields?.actionTypeId}
        />
      )}
    </Card>
  )
}
